import React from "react";
import { Navigate, useParams } from "react-router-dom";
import MeetExperience from "components/MeetPage/MeetExperience/MeetExperience";
import {
  BOURBON_CITY_CANONICAL_PATH,
  isBourbonCityMeetSlug,
} from "helpers/seo/buildMeetSeo";

/** Dynamic meet detail route — slug must match Contentful `gymnasticMeets` entry */
const MeetInfo = () => {
  const { meetId } = useParams();
  const slug = decodeURIComponent(meetId || "");

  if (isBourbonCityMeetSlug(slug)) {
    return <Navigate to={BOURBON_CITY_CANONICAL_PATH} replace />;
  }

  return <MeetExperience preferredSlug={slug} />;
};

export default MeetInfo;
